let defaultDashboard = {
    usersCount: 0,
    clientsCount: 0,
    freeClientsCount: 0,
    objectsCount: 0,
    orders: null
};

export default defaultDashboard;

